import React from 'react';
import { useState } from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Button, Flex, Text } from 'rebass';
import withSession from '../../../lib/withSession';
import { DurationSelectionNoKit, DurationSelectionWithKit } from './DurationSelection';
import { UpgradePro } from './UpgradePro';
import { useEffect } from 'react';
import { Mutation } from 'react-apollo';
import { CREATE_SESSION_GI_CHECKOUT_SESSION } from '../../../graphql';
import { ShippingAddress } from './ShippingAddress';
import { CompleteKit, CompleteNoKit } from './CompleteKit';
import UploadGILabResults from './UploadGILabResults';

export const SUBSCRIBE_GUT_RESET_NO_KITS_URL = '/programs/gut-reset/subscribe/no-kit';

const GuardedRoute = ({ condition, redirect, children }) => {
  if (!condition) return <Redirect to={redirect} />;
  return children;
};

const SubscribeNoKits = ({ history }) => {
  const [duration, setDuration] = useState();
  const [upgradePro, setUpgradePro] = useState(null);

  return (
    <>
      <Route
        path={`${SUBSCRIBE_GUT_RESET_NO_KITS_URL}/`}
        exact
        render={(props) => (
          <Flex flexDirection={'column'}>
            <Mutation
              mutation={CREATE_SESSION_GI_CHECKOUT_SESSION}
              onCompleted={async (res) => {
                let sessionId = null;
                if (res.createGiCheckoutSession) {
                  sessionId = res.createGiCheckoutSession.sessionId;
                }
                if (!sessionId) {
                  return;
                }
                const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);
                const stripe = await stripePromise;
                await stripe.redirectToCheckout({
                  sessionId: sessionId,
                });
              }}
            >
              {(createSession, { loading }) => (
                <DurationSelectionNoKit
                  onContinue={(d) => {
                    // console.log('click ', d)
                    createSession({
                      variables: {
                        forwardUrl: `${SUBSCRIBE_GUT_RESET_NO_KITS_URL}/upload-results`,
                        cancel_url: `${SUBSCRIBE_GUT_RESET_NO_KITS_URL}/`,
                        duration: d,
                        withKit: false,
                      },
                    });
                  }}
                />
              )}
            </Mutation>
          </Flex>
        )}
      />

      <Route
        path={`${SUBSCRIBE_GUT_RESET_NO_KITS_URL}/upload-results`}
        render={(props) => (
          // <GuardedRoute condition={upgradePro !== null} redirect={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/complete`}>
          <UploadGILabResults
            onSubmitted={() => {
              history.push(`${SUBSCRIBE_GUT_RESET_NO_KITS_URL}/complete`);
            }}
            onSkip={() => {
              history.push(`${SUBSCRIBE_GUT_RESET_NO_KITS_URL}/complete`);
            }}
          />
          // </GuardedRoute>
        )}
      />

      <Route
        path={`${SUBSCRIBE_GUT_RESET_NO_KITS_URL}/complete`}
        render={(props) => (
          // <GuardedRoute condition={upgradePro !== null} redirect={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/complete`}>
          <CompleteNoKit />
          // </GuardedRoute>
        )}
      />
    </>
  );
};

export default withRouter(withSession(SubscribeNoKits));
